<template>
  <div class="stickers-tools-tabs">
    <div class="stickers-tools-tabs__items">
      <button
        v-for="item in tabs"
        :key="item.value"
        :class="{
          'stickers-tools-tabs__item': true,
          'stickers-tools-tabs__item--active': item.value === tab
        }"
        type="button"
        @click.prevent="handleClick(item)"
      >
        <UseSvg
          v-if="item.icon"
          :icon="item.icon"
          width="24"
          height="24"
          class="stickers-tools-tabs__icon"
        />
        <span
          v-else
          :class="['stickers-tools-tabs__icon', `stickers-tools-tabs__icon--${item.value}`]"
        />
        {{ item.label }}
      </button>
    </div>
    <slot :tab="tab"></slot>
  </div>
</template>

<script setup>
import { ref } from "vue";
import UseSvg from "common/vue/components/UseSvg.vue";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";

const props = defineProps({
  artwork: [Object, null]
});

const tabs = [
  { label: "Background", icon: "tools-background", value: "background" },
  { label: "Border", value: "border" }
];

const tab = ref(tabs[0].value);

const handleClick = item => {
  if (props.artwork.processingImage) return;

  tab.value = item.value;

  const payload = {
    tab: item.value,
    page: "PDP",
    business_line: "Stickers",
    artwork_id: props.artwork.id,
    is_bg_removed: props.artwork.removeBackground
  };

  submitDtfEvent("sticker_tool_tab_change", payload);
};
</script>

<style lang="scss">
@import "frontend/init/jiffy/mixin";
@import "frontend/init/jiffy/settings";

.stickers-tools-tabs {
  &__items {
    display: flex;
    justify-content: center;
    gap: 12px;
    border-radius: 8px;
    background: $app-gray-modern-800;
    padding: 6px;

    @include with-desktop {
      gap: 40px;
    }
  }

  &__item {
    width: 100%;
    min-height: 60px;
    appearance: none;
    border: none;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 8px;
    padding: 6px 4px;
    color: $white;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.3;
    border-radius: 8px;
    background: transparent;

    &--active,
    &:hover {
      color: $primary-600;
      background-color: $white;
    }

    @include with-desktop {
      min-width: 110px;
      width: auto;
    }
  }

  &__icon {
    width: 24px;
    height: 24px;

    &--border {
      display: block;
      border-radius: 6px;
      border: 3px solid currentColor;
    }
  }
}
</style>
